<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/signPrairies/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
        @down="down"
    >
      <el-form-item label="模板名称" prop="mercRegisterName">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.mercRegisterName"
          placeholder="请输入模板名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="SN" prop="masn">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.masn"
          placeholder="请输入SN"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户号" prop="merNo">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.merNo"
          placeholder="请输入商户号"
        ></el-input>
      </el-form-item>
        <el-form-item label="是否有商户号" prop="existMerNo">
        <el-select v-model="formModel.existMerNo">
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否有押金">
        <el-select v-model="formModel.isDeposit">
          <el-option
            v-for="item in statusYajin"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="押金状态">
        <el-select v-model="formModel.yajinSetStatus">
          <el-option
            v-for="item in statusYajinStatus"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否有流量费">
        <el-select v-model="formModel.isSim">
          <el-option
            v-for="item in statusLiuliang"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="流量状态">
        <el-select v-model="formModel.simSetStatus">
          <el-option
            v-for="item in statusLiuliangStatus"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="日期">
        <el-date-picker
          v-model="formModel.payTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <!--<el-form-item label="支付方式">-->
      <!--<el-select v-model="formModel.payTypeScope">-->
      <!--<el-option-->
      <!--v-for="item in payTypeScope"-->
      <!--:key="item.dictKey"-->
      <!--:label="item.dictValue"-->
      <!--:value="item.dictKey"-->
      <!--&gt;-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="masn"
        label="SN号"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merNo"
        label="商户号"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="mercRegisterName"
        label="模板名称"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.status == 1 ? "启用" : "禁用" }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="brandName"
        label="品牌"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="qrRate"
        label="扫码费率(百分比)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cloudRate"
        label="云闪付费率(百分比)"
        min-width="180"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="creditRate"
        label="信用卡费率(百分比)"
        min-width="180"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="debitRate"
        label="借记卡费率(百分比)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="debitStandardCapping"
        label="借记卡封顶(元)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="additionalPro"
        label="D0额外手续费(元)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="isDeposit"
        label="是否有押金"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.isDeposit == 1">是</span>
          <span v-else-if="scope.row.isDeposit != 1">否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="yajinAmt"
        label="押金金额(元)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="yajinSetStatus"
        label="押金状态"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.yajinSetStatus == 1">成功</span>
          <span v-else-if="scope.row.yajinSetStatus == 0">失败</span>
          <span v-else-if="!scope.row.yajinSetStatus">--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isSim"
        label="是否有流量费"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.isSim == 1">是</span>
          <span v-else-if="scope.row.isSim != 1">否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="simAmt"
        label="流量费金额(元)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="simSetStatus"
        label="流量状态"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.simSetStatus == 1">成功</span>
          <span v-else-if="scope.row.simSetStatus == 0">失败</span>
          <span v-else-if="!scope.row.simSetStatus">--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="simDatePlan"
        label="流量计划首次收取时间"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="simDatePlan2"
        label="流量计划后续收取时间"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="simErrorMsg"
        label="流量错误提示"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="firstDay"
        label="首次天数"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="myInterval"
        label="后续收费间隔"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
         <el-table-column
      
        label="操作"
        min-width="260"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
          
            @click="openAddDialogNew(scope.row)"
            >设置流量费
          </el-button>
          <el-button
            type="text"
          
            @click="openAddDialog(scope.row)"
            >编辑
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="'编辑'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="300px"
      dialogWidth="589px"
    >
   

      <!-- 新增 -->
   
       <el-form-item label="SN" style="width: 100%" prop="simAmt">
        <el-input
          placeholder="请输入"
          :controls="false"
          v-model="dialogModel.masn"
          controls-position="right"
        
          style="width: 180px"
          disabled
        ></el-input>
        
      </el-form-item>
   
    

    
      <el-form-item label="是否有押金">
        <el-radio-group v-model="dialogModel.isDeposit">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="押金金额(元)" style="width: 100%"  prop="yajinAmt">
        <el-input-number
          placeholder="请输入"
          :controls="false"
          v-model="dialogModel.yajinAmt"
          controls-position="right"
          :step="0.1"
          @change="handleChange"
          style="width: 180px"
        ></el-input-number>
        <span>元</span>
      </el-form-item>
      <el-form-item label="是否有流量费">
        <el-radio-group v-model="dialogModel.isSim">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="流量费金额(元)" style="width: 100%" prop="simAmt">
        <el-input-number
          placeholder="请输入"
          :controls="false"
          v-model="dialogModel.simAmt"
          controls-position="right"
          :step="0.1"
          @change="handleChange"
          style="width: 180px"
        ></el-input-number>
        <span>元</span>
      </el-form-item>
      <el-form-item label="流量计划首次收取时间" prop="simDatePlan">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.simDatePlan"
          placeholder="请输入流量计划首次收取时间"
          style="width: 180px"
        ></el-input>
      </el-form-item>
       <el-form-item label="首次天数" prop="firstDay">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.firstDay"
          placeholder="请输入首次天数"
          style="width: 180px"
        ></el-input>
      </el-form-item>
       <el-form-item label="后续收费间隔" prop="myInterval">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.myInterval"
          placeholder="请输入后续收费间隔"
          style="width: 180px"
        ></el-input>
      </el-form-item>
    </form-dialog>
       
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ImageViewer from "../../dialog/ImageViewer";

import ShopService from "service/ShopService";
import TransactionService from "service/TransactionService";

import Server from "common/conf/Server";
import SelectLevel from "components/business/SelectLevel";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import Institutionlist from "service/Ainstitution";
import Prairies from "service/Prairies";
import ShopPayment from "../ShopManagement/ShopPayment.vue";
export default {
  name: "apppointsshopmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectLevel,
    ImageViewer,
    ShopPayment,
  },
  data() {
    return {
          statusList: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "1",
          value: "是",
        },
        {
          id: "0",
          value: "否",
        },
      ],
      uploadUrl: Server[process.env.NODE_ENV],
      show: false,
      formModel: {
        mercRegisterName: "",
        masn: "",
        merNo: "",
        isDeposit: "",
        yajinSetStatus: "",
        isSim: "",
        simSetStatus: "",
        existMerNo: '',
        payTime: ''
      },
      statusYajin: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "1",
          value: "是",
        },
        {
          id: "0",
          value: "否",
        },
      ],
      statusYajinStatus: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "1",
          value: "成功",
        },
        {
          id: "0",
          value: "失败",
        },
      ],
      statusLiuliang: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "1",
          value: "是",
        },
        {
          id: "0",
          value: "否",
        },
      ],
      statusLiuliangStatus: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "1",
          value: "成功",
        },
        {
          id: "0",
          value: "失败",
        },
      ],
      tableData: [],
      submitService: Prairies.signList,
      page: {},
      isPage: false,
      itemId: "",
      dialogModelNew: {
        masn: ""
      },
      dialogModel: {
        mercRegisterName: "",
        brandCode: "",
        qrRate: "",
        cloudRate: "",
        creditRate: "",
        debitRate: "",
        debitStandardCapping: "",
        additionalPro: "",
        isDeposit: 0,
        yajinAmt: "",
        isSim: 0,
        simAmt: "",
        simFeePayTimes: "",

        // goodName: "",
      },
      payTypeScope: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      dialogRulesNew: {
        masn: [  {
            required: true,
            message: "请输入",
          },]
      },
      dialogRules: {
        myInterval: [
          {
            required: true,
            message: "请输入",
          },
        ],
        firstDay: [
          {
            required: true,
            message: "请输入",
          },
        ],
        simDatePlan: [
          {
            required: true,
            message: "请输入",
          },
        ],
     
        activeSubTypeId: [
          {
            required: true,
            message: "请输入",
          },
        ],
        debitRate: [
          {
            required: true,
            message: "请输入",
          },
        ],
        debitStandardCapping: [
          {
            required: true,
            message: "请输入",
          },
        ],
        additionalPro: [
          {
            required: true,
            message: "请输入",
          },
        ],
        simAmt: [
          {
            required: true,
            message: "请输入",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入",
          },
        ],
        yajinAmt: [
          {
            required: true,
            message: "请输入",
          },
        ],
        artNo: [
          {
            required: true,
            message: "请输入",
          },
        ],
        goodName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        residueNo: [
          {
            required: true,
            message: "请输入",
          },
        ],
        payTypeScope: [
          {
            required: true,
            message: "请选择",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入",
          },
        ],
        signPrice: [
          {
            required: true,
            message: "请输入",
          },
        ],
        couponGroupId: [
          {
            required: true,
            message: "请输入",
          },
        ],
        imgUrl: [
          {
            required: true,
            message: "请选择你要上传的图片",
          },
        ],
      },
      typeList: [
        {
          dictKey: "1",
          dictValue: "每月推荐",
        },
        {
          dictKey: "2",
          dictValue: "积分精品",
        },
        {
          dictKey: "3",
          dictValue: "优惠券",
        },
      ],
      typeTwoList: [],
      isFlag: false,
      checkAll: false,
      checkedCities: [],
      couponList: [],
      loading: false,
      brandCodeList: [], // 品牌编号
    };
  },
  // inject: ["reload"],
  mixins: [loadMixin, dialogMixin,],
  mounted() {
    
    this.getTypeNames("merchantPayType", (res) => {
      this.payTypeScope = [...this.payTypeScope, ...res];
    });
    this.getTypeNames("积分精品商城", (res) => {
      this.typeTwoList = res;
    });
    this.getTypeNames("燎原品牌编号", (res) => {
      this.brandCodeList = res;
    });
    this.load();
  },
  computed: {
    submitData() {
        if (this.formModel.payTime == null || this.formModel.payTime == "") {
        this.formModel.payTime = [];
      }
      this.params = {
        mercRegisterName: this.formModel.mercRegisterName,
        masn: this.formModel.masn,
        merNo: this.formModel.merNo,
        simSetStatus: this.formModel.simSetStatus,
        isSim: this.formModel.isSim,
        yajinSetStatus: this.formModel.yajinSetStatus,
        isDeposit: this.formModel.isDeposit,
        existMerNo: this.formModel.existMerNo,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
        if (this.formModel.payTime.length) {
        this.params.startDate = this.formModel.payTime[0];
        this.params.endDate = this.formModel.payTime[1];
      }
      return this.params;
    },
    
    dialogData() {
      const params = {
        isSim: this.dialogModel.isSim,
        simAmt: this.dialogModel.simAmt,
        isDeposit: this.dialogModel.isDeposit,
        yajinAmt: this.dialogModel.yajinAmt,
        simDatePlan: this.dialogModel.simDatePlan,
        firstDay: this.dialogModel.firstDay,
        myInterval: this.dialogModel.myInterval,
       id: this.itemId
        // goodName: this.dialogModel.goodName,
      };

      return params;
    },
    dialogService() {
      return Prairies.editData;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "tatSimpleId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
          payTime:''
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getCouponList();
    },
    // 启用禁用
    handleStatus(id, status) {
      this.showConfirm(`确定${status == 1 ? "禁用" : "启用"}该模板？`)
        .then(() => {
          this.doStatus(id, status);
        })
        .catch(() => {});
    },
    doStatus(id, status) {
      this.doLoad(
        Prairies.openAddprairies,
        {
          userId: this.userId,
          id: id,
          status: status == 1 ? 0 : 1,
          tatId: this.tatId,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.contents.optMsg);
            this.getList();
          });
        },
        "信息获取失败"
      );
    },
    getCouponList() {
      this.doLoad(
        TransactionService.coupongroupmanageList,
        {
          size: 100,
        },
        (res) => {
          this.couponList = res.contents.rows;
        },
        "信息获取失败"
      );
    },

    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        ShopService.apppointsshopmanageDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
  openAddDialogNew(item, flag) {
    console.log(item)
       this.showConfirm(`确定设置流量费？`)
        .then(() => {
          this.doStatus(item);
        })
        .catch(() => {});
    },
     doStatus(item) {
      this.doLoad(
        Prairies.signLiuliang,
        {
         
          masn: item.masn,
        
         
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.contents);
            this.getList();
          });
        },
        "信息获取失败"
      );
    },
    openAddDialog(item, flag) {
     this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },
    dialogClose() {
      this.dialogModel = {
        mercRegisterName: "",
        brandCode: "",
        qrRate: "",
        cloudRate: "",
        creditRate: "",
        debitRate: "",
        debitStandardCapping: "",
        additionalPro: "",
        isDeposit: 0,
        activeSubTypeId: "",
        isSim: 0,
        simAmt: "",
        simFeePayTimes: "",
      };
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList()
    },
   down() {
      this.doLoad(
        FinanceService.sumTatAccDtl,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogObj = result;
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
           this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
        this.tableData.forEach((item) => {
          this.brandCodeList.forEach((itemTwo) => {
            console.log(itemTwo);
            if (itemTwo.dictKey == item.brandCode) {
              item.brandName = itemTwo.dictValue;
            }
          });
        });
     
      });
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.imgUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    beforeAvatarUploadOther(file) {
      this.loading = true;
      console.log(file);
      const isVideo = file.type === "video/mp4";

      const isLt2M = file.size / 1024 / 1024 < 12;
      console.log(isVideo && !isLt2M, isVideo, !isLt2M);
      if (isVideo && !isLt2M) {
        this.loading = false;
        this.$message.error("上传视频大小不能超过 12MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    otherError() {
      this.loading = false;
    },
    formatterTableDataTypeTwo(row, column, cellValue, index) {
      let value = "--";
      if (row.type == 3) {
        return row.couponGroupName ? row.couponGroupName : value;
      }
      if (row.type == 2) {
        return cellValue ? cellValue : value;
      }
      return value;
    },
    formatterTableDataType(row, column, cellValue, index) {
      let value = "--";
      this.typeList.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    handleAvatarSuccess1(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.otherImgsUrl.push(res.contents);
        this.loading = false;
      });
    },
    handleImgClick(url) {
      this.dialogModel.otherImgsUrl = this.dialogModel.otherImgsUrl.filter(
        (item) => item !== url
      );
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}

.alliconUrl {
  /* width: 50px;
        height: 50px; */
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

/deep/ .el-upload--picture-card {
  /* background-color: #fbfdff; */
  border: 0px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 35px !important;
  height: 35px !important;
  line-height: 35px !important;
  vertical-align: top;
}

/deep/ .el-upload--picture-card i {
  font-size: 40px;
  color: #8c939d;
}

.newimg {
  display: flex;
  flex-wrap: wrap;
}

.newimg div:nth-child(2) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(5) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(8) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(11) {
  margin: 0px 10px 10px 10px;
}

.newavatar {
  width: 70px;
  height: 70px;
  display: block;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
}

.newavatar:hover {
  width: 70px;
  height: 70px;
  border: 1px dashed red;
  border-radius: 6px;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: 5px 5px 0px 5px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/Prairies/signPrairies.vue